module.exports = __webpack_public_path__ + "static/assets/99113ba8370c224ff82f88ffa155ac41.svg";